module.exports = __webpack_public_path__ + "img/cmps/Like/img/icon-like.1b56b531f433a3d3c3ad34600e89a0e2.png";